.buttonsRow {
  padding-bottom: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.panes {
  display: flex;
  gap: 12px;
}

.panes > * {
  padding-top: 12px;
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
